module.exports = __webpack_public_path__ + "media/packs/images/flags/NE-d4fbb479035800d85c0b758cd577cac5.png";